<template>
  <div class="pricing-root">
    <main class="pricing-content">
      <div class="container">
        <div class="pricing-plans">
          <!-- 基础版 -->
          <div class="pricing-card">
            <div class="card-header">
              <h2>基础版</h2>
              <div class="header-banner">
                <span class="banner-text">全网最低定价</span>
                <span class="offer-badge">随用随充</span>
              </div>
            </div>
            <div class="price-list">
              <div class="price-item">
                <span class="item-name">实时语音转录</span>
                <div class="price-wrapper">
                  <span class="item-price normal-price">0.2币/分钟</span>
                </div>
              </div>
              <div class="price-item">
                <span class="item-name">AI快答</span>
                <div class="price-wrapper">
                  <span class="item-price normal-price">3币/次</span>
                </div>
              </div>
              <div class="price-item">
                <span class="item-name">深度回答</span>
                <div class="price-wrapper">
                  <span class="item-price normal-price">4币/次</span>
                </div>
              </div>
              <div class="price-item">
                <span class="item-name">截图回答</span>
                <div class="price-wrapper">
                  <span class="item-price normal-price">5币/次</span>
                </div>
              </div>
            </div>
            <div class="price-notes">
              <p class="note-item">小贴士：</p>
              <p class="note-item">1.充值金额将自动转化为"面试币"，1元=1币</p>
              <!-- <p class="note-item">2.一次普通面试（60分钟+5次AI快答+1次截图）约70元</p> -->
              <p class="note-item">2.充值金额需为1元的整数倍</p>
              <p class="note-item">更多详情请查看 <a href="#" @click.prevent="goToTutorialCenter" style="color: #2563eb; text-decoration: none;">教程中心</a></p>
            </div>
            <div class="recharge-section">
              <h3 class="recharge-title">请选择充值金额</h3>
              
                            <div class="amount-grid">
                <div class="amount-card" :class="{ 'selected': selectedAmount === 10 }" @click="selectAmount(10)">
                  <div class="amount-value">10元</div>
    
                </div>
         
                <div class="amount-card" :class="{ 'selected': selectedAmount === 50 }" @click="selectAmount(50)">
                  <div class="amount-value">50元</div>
 
                </div>
                <div class="amount-card" :class="{ 'selected': selectedAmount === 100 }" @click="selectAmount(100)">
                  <div class="amount-value">100元</div>
   
                </div>
                <div class="amount-card custom-amount" :class="{ 'selected': isCustomSelected }">
                  <div class="amount-value">
                    <el-input 
                      v-model="customAmount"
                      placeholder="自定义金额"
                      class="custom-input"
                      type="number"
                      min="1"
                      step="1"
                      @click.stop="selectCustomAmount"
                      @input="onCustomAmountInput"
                      @keydown="onCustomAmountKeydown"
                      @paste="onCustomAmountPaste">
                    </el-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button class="btn-primary" @click="handleRecharge">支付宝</button>
              <button class="btn-primary" @click="handleRechargeWechat">微信</button>
            </div>
          </div>

          <!-- 引入支付弹窗组件 -->
          <PaymentModal v-if="showPaymentModal" ref="paymentModal" @close-modal="handleModalClose"></PaymentModal>
          <WechatPaymentModal v-if="showWechatPaymentModal" ref="wechatPaymentModal" @close-modal="handleWechatModalClose"></WechatPaymentModal>

          <!-- 会员版 -->
          <div class="pricing-card coming-soon">
            <div class="card-header">
              <h2>会员版</h2>
              <p class="subtitle">敬请期待</p>
            </div>
            <div class="coming-soon-content">
              <div class="coming-soon-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
                </svg>
              </div>
              <p>更多优惠特权，即将上线</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import PaymentModal from '@/views/HomepageMenu/PaymentModal.vue';
import WechatPaymentModal from '@/views/HomepageMenu/WechatPaymentModal.vue';
import { useStore } from "@/store";
import { formatDateTime } from '@/utils/common';

export default {
  name: 'PricingPage',
  components: {
    PaymentModal,
    WechatPaymentModal
  },
  data() {
    return {
      showPaymentModal: false, // 是否显示支付弹窗
      showWechatPaymentModal: false, // 是否显示微信支付弹窗
      customAmount: '', // 自定义金额输入框的值
      selectedAmount: null, // 选中的金额
      isCustomSelected: false // 是否选中自定义金额
    };
  },
  methods: {
    // 处理 code = 4002 的情况（用户不存在）
    handleCode4002() {
      const store = useStore();
      store.isLogin = false;
      store.token = "";
      store.refreshToken = "";
      this.$router.push({
        name: 'home',
        query: { activeIndex: 1 }
      });
      this.$message.error('用户不存在，请重新登录');
    },
    
    handleModalClose() {
      this.showPaymentModal = false;
    },
    
    handleWechatModalClose() {
      this.showWechatPaymentModal = false;
    },
    
    // 选择金额
    selectAmount(amount) {
      this.selectedAmount = amount;
      this.isCustomSelected = false;
      this.customAmount = '';
    },
    
    // 选择自定义金额
    selectCustomAmount() {
      this.selectedAmount = null;
      this.isCustomSelected = true;
    },
    
    // 自定义金额输入
    onCustomAmountInput() {
      if (this.customAmount) {
        this.selectedAmount = null;
        this.isCustomSelected = true;
        
        // 只允许正整数
        const value = this.customAmount.toString();
        const cleanValue = value.replace(/[^0-9]/g, '');
        
        if (cleanValue !== value) {
          this.customAmount = cleanValue;
        }
        
        // 去除前面的0，但保留单个0
        if (this.customAmount && this.customAmount.length > 1) {
          this.customAmount = this.customAmount.replace(/^0+/, '');
          // 如果去除前导0后为空，则设为空
          if (this.customAmount === '') {
            this.customAmount = '';
          }
        }
        
        // 验证金额必须大于0
        const amount = parseInt(this.customAmount);
        if (amount <= 0) {
          this.customAmount = '';
        }
      }
    },
    
    // 键盘输入验证
    onCustomAmountKeydown(event) {
      // 允许的键：数字键、退格键、删除键、方向键、Tab键
      const allowedKeys = [
        'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
        'Tab', 'Enter', 'Home', 'End'
      ];
      
      // 允许数字键
      if (event.key >= '0' && event.key <= '9') {
        return;
      }
      
      // 允许控制键
      if (allowedKeys.includes(event.key)) {
        return;
      }
      
      // 允许Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X等组合键
      if (event.ctrlKey || event.metaKey) {
        return;
      }
      
      // 阻止其他字符输入
      event.preventDefault();
    },
    
    // 粘贴验证
    onCustomAmountPaste(event) {
      event.preventDefault();
      
      // 获取粘贴的内容
      const paste = (event.clipboardData || window.clipboardData).getData('text');
      
      // 只保留数字
      let cleanValue = paste.replace(/[^0-9]/g, '');
      
      // 去除前导0
      if (cleanValue && cleanValue.length > 1) {
        cleanValue = cleanValue.replace(/^0+/, '');
      }
      
      if (cleanValue) {
        this.customAmount = cleanValue;
        this.onCustomAmountInput();
      }
    },
    
    async payMent(amount) {
      this.store = useStore();
      if(!this.store.token){
        this.$message.error('请先登录');
        return;
      }
      // 显示支付弹窗
      this.showPaymentModal = true;
      //当前日期 格式yyyy-MM-dd   当前时间 格式yyyy-MM-dd HH:mm:ss
      const currentDate = formatDateTime(new Date(), 'yyyy-MM-dd'); // 当前日期
      const currentTime = formatDateTime(new Date()); // 当前时间（完整格式）

      const obj = { 
         userId: "",//线上不用传，后台通过token获取useId
          productName: "linkoffer-充值",//必传，会展示在支付宝账单
          orderNo: "",
          orderPrice: amount,  // 单位 元，必传
          orderIp: "127.0.0.1",// 必传
          orderDate: currentDate, // 必传，当前日期
          orderTime: currentTime,//必传，当前时间
          orderPeriod: 100,//必传，订单有效期，minute，可以固定传100
          returnUrl: "www.baidu.com",//必传，用于支付后跳转页面
          notifyUrl: "www.baidu.com",//必传，可以传一个非空字符串
          sign: "test",//必传，可以传test
          remark: "消费",//必传
          payType: "ALI_SCAN_PAY",//支付宝扫码
          fundInfoType: "RECHARGE",//必传，固定传RECHARGE
          qr_pay_mode: "4"//支付宝支付前置模式参数，值4实现可定义宽度的嵌入式二维码
      }; // 创建一个对象，包含金额和其他参数
      const url = `/api/pay/ali/pcPay`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.store.token,
        },
        body: JSON.stringify(obj)
      });
      
      // 检查响应类型，判断是 JSON 还是 HTML/文本
      const contentType = response.headers.get('content-type') || '';
      
      // 如果是 JSON 响应，先检查 code（无论响应是否成功）
      if (contentType.includes('application/json')) {
        try {
          const data = await response.json();
          // 检查 code = 4002（用户不存在）
          if (data && data.code === 4002) {
            this.handleCode4002();
            return;
          }
          // 如果响应不成功，显示错误信息
          if (!response.ok) {
            this.$message.error(data.message || '支付请求失败');
            return;
          }
          // 如果响应成功但不是预期的 HTML，可能需要特殊处理
          this.$message.error(data.message || '支付请求失败');
          return;
        } catch (error) {
          // JSON 解析失败，按文本处理
          console.error('JSON 解析失败:', error);
        }
      }
      
      // 如果响应不成功且不是 JSON，显示错误信息
      if (!response.ok) {
        this.$message.error('支付请求失败');
        return;
      }
      
      // 如果是 HTML 或其他文本格式，正常处理
      const formHtml = await response.text(); // 获取form表单内容
      // 将form内容传递给支付弹窗生成二维码
      this.$refs.paymentModal.setQrContent(formHtml);
      this.$refs.paymentModal.showPaymentModal(); // 显示支付弹窗
    },
    handleRecharge() {
      let amount = 0;
      
      if (this.selectedAmount) {
        // 如果选中了预设金额
        amount = this.selectedAmount;
      } else if (this.isCustomSelected && this.customAmount) {
        // 如果选中了自定义金额
        amount = parseFloat(this.customAmount);
        if (isNaN(amount) || amount < 0.1) {
          this.$message.error('充值金额不能少于0.1元');
          return;
        }
      } else {
        this.$message.error('请选择充值金额');
        return;
      }
      
      // 调用支付接口
      this.payMent(amount);
    },
    async payMentWechat(amount) {
      this.store = useStore();
      if(!this.store.token){
        this.$message.error('请先登录');
        return;
      }
      // 显示微信支付弹窗
      this.showWechatPaymentModal = true;
      //当前日期 格式yyyy-MM-dd   当前时间 格式yyyy-MM-dd HH:mm:ss
      const currentDate = formatDateTime(new Date(), 'yyyy-MM-dd'); // 当前日期
      const currentTime = formatDateTime(new Date()); // 当前时间（完整格式）

      const obj = { 
         userId: "",//线上不用传，后台通过token获取useId
          payKey: "123",//必传
          productName: "linkoffer-充值",//必传，会展示在微信账单
          orderNo: "",//`test_${formatDateTime(new Date(), 'yyyyMMdd')}_${Date.now()}`,//必传，生成唯一订单号
          orderPrice: amount,  // 单位 元，必传
          orderIp: "127.0.0.1",// 必传
          orderDate: currentDate, // 必传，当前日期
          orderTime: currentTime,//必传，当前时间
          orderPeriod: 100,//必传，订单有效期，minute，可以固定传100
          returnUrl: "www.baidu.com",//必传，用于支付后跳转页面
          notifyUrl: "www.baidu.com",//必传，可以传一个非空字符串
          sign: "test",//必传，可以传test
          remark: "消费",//必传
          payType: "WX_SCAN_PAY",//微信扫码
          fundInfoType: "RECHARGE"//必传，固定传RECHARGE
      }; // 创建一个对象，包含金额和其他参数
      const url = `/api/pay/wx/prePay`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "api-key": "your-api-key-here", // 根据实际api-key调整
          Authorization: "Bearer " + this.store.token,
        },
        body: JSON.stringify(obj)
      });
      
      // 检查响应类型，判断是 JSON 还是文本
      const contentType = response.headers.get('content-type') || '';
      
      // 如果是 JSON 响应，先检查 code（无论响应是否成功）
      if (contentType.includes('application/json')) {
        try {
          const data = await response.json();
          // 检查 code = 4002（用户不存在）
          if (data && data.code === 4002) {
            this.handleCode4002();
            return;
          }
          // 如果响应不成功，显示错误信息
          if (!response.ok) {
            this.$message.error(data.message || '支付请求失败');
            return;
          }
          // 如果响应成功但不是预期的文本，可能需要特殊处理
          this.$message.error(data.message || '支付请求失败');
          return;
        } catch (error) {
          // JSON 解析失败，按文本处理
          console.error('JSON 解析失败:', error);
        }
      }
      
      // 如果响应不成功且不是 JSON，显示错误信息
      if (!response.ok) {
        this.$message.error('支付请求失败');
        return;
      }
      
      // 如果是文本格式，正常处理
      const wechatPayUrl = await response.text(); // 获取微信支付URL，如：weixin://wxpay/bizpayurl?pr=gk99uVFz3
      console.log('微信支付URL:', wechatPayUrl);
      
      // 将微信支付URL传递给微信支付弹窗生成二维码
      this.$refs.wechatPaymentModal.setQrContent(wechatPayUrl);
      this.$refs.wechatPaymentModal.showPaymentModal(); // 显示微信支付弹窗
    },
    
    handleRechargeWechat() {
      let amount = 0;
      
      if (this.selectedAmount) {
        // 如果选中了预设金额
        amount = this.selectedAmount;
      } else if (this.isCustomSelected && this.customAmount) {
        // 如果选中了自定义金额
        amount = parseFloat(this.customAmount);
        if (isNaN(amount) || amount < 0.1) {
          this.$message.error('充值金额不能少于0.1元');
          return;
        }
      } else {
        this.$message.error('请选择充值金额');
        return;
      }
      
      // 调用微信支付接口
      this.payMentWechat(amount);
    },
    goToTutorialCenter() {
      this.$router.push({
        name: 'home',
        query: { activeIndex: 2 }
      });
    },
    goToContact() {
      this.$router.push({
        name: 'home',
        query: { activeIndex: 5 }
      });
    }
  }
};
</script>

<style scoped>
.pricing-root {
  min-height: 100vh;
  background-color: #f8fafc;
  padding: 8px 0;
}

.pricing-content {
  width: 100%;
}

.container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
}

.pricing-plans {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 48px;
  margin: 8px auto;
  max-width: 800px;
}

.pricing-card {
  background: white;
  border-radius: 16px;
  padding: 28px 40px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  min-height: 280px;
}

.card-header {
  text-align: center;
  margin-bottom: 16px;
}

.card-header h2 {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 12px;
}

.header-banner {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background: linear-gradient(90deg, rgba(255, 244, 230, 0.5) 0%, #ffe8cc 100%);
  border-radius: 0;
  padding: 10px 0;
  margin-top: 8px;
  position: relative;
  overflow: visible;
  gap: 0;
}

.banner-text {
  color: #333;
  font-size: 15px;
  font-weight: 500;
  text-align: right;
  padding-right: 0;
}

.offer-badge {
  background: linear-gradient(135deg, #ff7744, #ff9966);
  color: white;
  font-size: 13px;
  font-weight: 600;
  padding: 8px 20px;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(255, 119, 68, 0.35);
  position: relative;
  margin-right: 0;
  border-radius: 0 4px 4px 0;
}

.offer-badge::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 19px 0 19px 15px;
  border-color: transparent transparent transparent #ffe8cc;
}

.subtitle {
  color: #666;
  font-size: 14px;
}

.price-list {
  flex: 1;
  margin: 0 -8px;
  padding: 0 8px;
}

.price-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.price-item:last-child {
  border-bottom: none;
}

.item-name {
  color: #333;
  font-size: 14px;
  flex-shrink: 0;
}

.price-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.item-price {
  font-weight: 500;
  font-size: 14px;
}

.item-price.original {
  color: #999;
  text-decoration: line-through;
  font-size: 13px;
}

.item-price.offer {
  color: #ff8c42;
  font-weight: 600;
}

/* 正常价格显示为黄色 */
.item-price.normal-price {
  color: #ff8c42;
  font-weight: 600;
  font-size: 15px;
}

/* 特殊：实时语音转录的优惠价为橙色 */
.price-item:first-child .item-price.offer {
  color: #ff8c42;
}

.savings {
  color: #888;
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
}

.adjustment {
  color: #888;
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
}

.price-notes {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #eee;
}

.note-item {
  color: #666;
  font-size: 13px;
  line-height: 1.6;
  margin-bottom: 6px;
}

.note-item:last-child {
  margin-bottom: 0;
}

.price-notes a {
  color: #2563eb;
  text-decoration: none;
}

.price-notes a:hover {
  text-decoration: underline;
}

.card-footer {
  margin-top: 20px;
  text-align: center;
}

.card-footer .btn-primary {
  width: 130px;
}

.card-footer .btn-primary:first-child {
  margin-right: 12px;
}

.btn-primary {
  background: #2563eb;
  color: white;
  border: none;
  padding: 10px 32px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-primary:hover {
  background: #1d4ed8;
}

.coming-soon {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.coming-soon-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 40px;
}

.coming-soon-icon {
  margin-bottom: 16px;
  color: #94a3b8;
  align-self: center;
}

.coming-soon-content p {
  color: #666;
  font-size: 14px;
  text-align: center;
  width: 100%;
}

@media (max-width: 768px) {
  .pricing-plans {
    grid-template-columns: 1fr;
    max-width: 400px;
  }

  .pricing-card {
    padding: 24px;
    min-height: 350px;
  }

  .pricing-root {
    padding: 40px 0;
  }

  .header-banner {
    padding: 8px 0;
    flex-wrap: nowrap;
  }

  .banner-text {
    font-size: 13px;
    padding-right: 0;
  }

  .offer-badge {
    font-size: 11px;
    padding: 6px 16px;
    margin-right: 0;
    border-radius: 0 3px 3px 0;
  }

  .offer-badge::before {
    border-width: 16px 0 16px 12px;
  }

  .price-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    padding: 12px 0;
  }

  .price-wrapper {
    width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 6px;
  }

  .item-price.original {
    font-size: 12px;
  }

  .item-price.offer {
    font-size: 13px;
  }

  .savings,
  .adjustment {
    font-size: 11px;
  }
}

.pricing-column {
  width: 50%;
}

/* 充值金额选择样式 */
.recharge-section {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #eee;
}

.recharge-title {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 16px;
  text-align: center;
}

.amount-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 20px;
}

.amount-card {
  background: #ffffff;
  border: 2px solid #e5e5e5;
  border-radius: 12px;
  padding: 20px 16px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: visible;
}

.amount-card:hover {
  border-color: #2563eb;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
}

.amount-card.selected {
  border-color: #2563eb;
  background: #f0f7ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
}

.custom-amount.selected {
  border-color: #2563eb;
  background: #f0f7ff;
}

.amount-card:active {
  transform: translateY(0);
}

.amount-value {
  font-size: 12px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 4px;
}

.amount-desc {
  font-size: 12px;
  color: #666;
  line-height: 1.2;
}

.custom-amount {
  border-style: dashed;
  border-color: #d1d5db;
  cursor: text;
}

.custom-amount:hover {
  border-color: #2563eb;
  background: #f8fafc;
}

.custom-amount .amount-value {
  pointer-events: auto;
  z-index: 10;
  position: relative;
}

.custom-input {
  width: 100%;
}

.custom-input {
  width: 100%;
}

.custom-input :deep(.el-input__inner) {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  border: none;
  background: transparent;
  padding: 8px 0;
  height: 24px;
  pointer-events: auto;
  min-height: 24px;
}

.custom-input :deep(.el-input__inner):focus {
  box-shadow: none;
  border: none;
  outline: none;
}

.custom-input :deep(.el-input__inner)::placeholder {
  color: #999;
  font-size: 16px;
  font-weight: normal;
}

.custom-input :deep(.el-input__wrapper) {
  border: none;
  background: transparent;
  box-shadow: none;
  padding: 0;
}

.custom-input :deep(.el-input__wrapper):focus {
  box-shadow: none;
  border: none;
  background: transparent;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .amount-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
  
  .amount-card {
    padding: 12px 8px;
  }
  
  .amount-value {
    font-size: 16px;
  }
  
  .amount-desc {
    font-size: 11px;
  }

  .card-header h2 {
    font-size: 18px;
  }
}
</style> 